<template>
  <div class="info-cell" :class="{'active-info-cell': isFocus}">
    <label :for="id" class="label">
      {{label}}
    </label>
    <div class="info-cell__field">
      <input type="text"
             class="info-cell__input"
             :id="id"
             :placeholder="placeholder"
             :value="value"
             :name="name"
             @input="$emit('input', $event.target.value)"
             @focus="$emit('update:error', false); isFocus = true;"
             @blur="isFocus = false;"
             :disabled="disabled"
      >
    </div>
  </div>
</template>

<script>

  export default {
    model: {
      prop: "value",
      event: "input",
    },
    props: {
      id: {
        type: String,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
      value: {
        type: String,
        default: "",
      },
      placeholder: {
        type: String,
        default: "",
      },
      name: {
        type: String,
        default: "",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isFocus: false,
      }
    },
  }

</script>

<style scoped>
  .active-info-cell {
    border-color: #455371;
  }
</style>